import $ from 'jquery'

export default dateValidation => {
  let y = new Date().getFullYear()
  let validateFunc = function (target) {
    let m = Number($(target).closest('.c-form-inline').find('select[name^=visit_mon]').val())
    let day = $(target).closest('.c-form-inline').find('select[name^=visit_day]')
    let d = Number(day.val())
    if (y && m) {
      let ds   = new Date(y, m, 0)
      let dsn  = Number(ds.getDate())
      let html = ''
      for (let i = 1; i <= dsn; i++) {
        if (i === d) {
          html += `<option value=${i} selected>${i}</option>`
        } else {
          html += `<option value=${i}>${i}</option>`
        }
      }
      if (d === 0) {
        day[0].innerHTML = html
        day.val('')
      } else if (dsn < d) {
        day[0].innerHTML = html
        day.val('')
      } else {
        day[0].innerHTML = html
      }
    }
  }
  let $visitSelect = $('.p-entry__form-visit .p-entry__form-select select')
  $visitSelect.map(function (i) {
    if ($visitSelect[i].name.match(/^visit_mon_.+/)) {
      validateFunc($visitSelect[i])
    }
  })
  $('.p-entry__form-visit .p-entry__form-select select').on('change', function () {
    validateFunc(this)
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/entry.js